import React from 'react';
import {
    ActivityIndicator,
    View
} from '../../../custom-packages/react-native-components-in-react/react-native-components-in-react';

const ActivityIndicatorWrapper = (props) => {

    return <View
        style={{
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 170,
            ...props.style
        }}
    >
        <ActivityIndicator style={{  }} />
    </View>;
}

export default ActivityIndicatorWrapper;